<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <div class="weui-cell" slot="pc_code">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pc_code || "单据编号"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pc_code }}
          </div>
        </div>
        <div class="weui-cell" slot="pc_pjcode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pc_pjcode || "立项单号"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pc_pjcode }}
          </div>
        </div>
        <div class="weui-cell" slot="pj_dename">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_dename || "项目名称"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pj_dename }}
          </div>
        </div>
        <div class="weui-cell" slot="pj_emname">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_emname || "项目负责人"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pj_emname }}
          </div>
        </div>
        <div class="weui-cell" slot="pj_emtel">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_emtel || "联系电话"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pj_emtel }}
          </div>
        </div>
        <div class="weui-cell" slot="pc_rpname">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pc_rpname || "研发阶段"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pc_rpname }}
          </div>
        </div>
        <div class="weui-cell" slot="pc_opinion">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pc_opinion || "项目总结意见"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              rows="5"
              autofocus
              v-model="form.main.pc_opinion"
              placeholder="请输入总结意见"
              placeholder-class="weui-input__placeholder"
            />
          </div>
        </div>
      </custom-layout>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.pcd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="ta_code">
              <label class="weui-form-preview__label">{{
                customLabel.ta_code || "任务单号"
              }}</label>
              <span class="weui-form-preview__value">{{ item.plmProjTaskDTO.ta_code }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ta_task">
              <label class="weui-form-preview__label">{{
                customLabel.ta_task || "任务名称"
              }}</label>
              <span class="weui-form-preview__value">{{ item.plmProjTaskDTO.ta_task }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ta_taskstatus">
              <label class="weui-form-preview__label">{{
                customLabel.ta_taskstatus || "任务状态"
              }}</label>
              <span class="weui-form-preview__value">{{ item.plmProjTaskDTO.ta_taskstatus }}</span>
            </div>
            <div class="weui-form-preview__item" slot="rd_taskreq">
              <label class="weui-form-preview__label">{{
                customLabel.rd_taskreq || "任务要求"
              }}</label>
              <span class="weui-form-preview__value">{{ item.plmProjTaskDTO.rd_taskreq }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ta_taskreq">
              <label class="weui-form-preview__label">{{
                customLabel.ta_taskreq || "已完成任务要求"
              }}</label>
              <span class="weui-form-preview__value">{{ item.plmProjTaskDTO.ta_taskreq }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ta_emname">
              <label class="weui-form-preview__label">{{
                customLabel.ta_emname || "责任人"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.plmProjTaskDTO.ta_emname
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ta_planbegindate">
              <label class="weui-form-preview__label">{{
                customLabel.ta_planbegindate || "计划开始日期"
              }}</label>
              <span class="weui-form-preview__value"  v-format="'yyyy-MM-dd hh:mm'">{{
                item.plmProjTaskDTO.ta_planbegindate
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ta_planenddate">
              <label class="weui-form-preview__label">{{
                customLabel.ta_planenddate || "计划完成日期"
              }}</label>
              <span class="weui-form-preview__value"  v-format="'yyyy-MM-dd hh:mm'">{{
                item.plmProjTaskDTO.ta_planenddate
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ta_actbegindate">
              <label class="weui-form-preview__label">{{
                customLabel.ta_actbegindate || "实际开始日期"
              }}</label>
              <span class="weui-form-preview__value"  v-format="'yyyy-MM-dd hh:mm'">{{
                item.plmProjTaskDTO.ta_actbegindate
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ta_actenddate">
              <label class="weui-form-preview__label">{{
                customLabel.ta_actenddate || "实际完成日期"
              }}</label>
              <span class="weui-form-preview__value"  v-format="'yyyy-MM-dd hh:mm'">{{
                item.plmProjTaskDTO.ta_actenddate
              }}</span>
            </div>
          </custom-layout>
        </div>
      </div>

    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">提交</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
      >取消</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/plm/projcheck",
      codeField: "pc_code",
      statusField: "pc_statuscode",
      caller: "PlmProjCheck",
      xtype: "plm-projcheck-formpanel",
      form: {
        main: {
          pc_opinion:''
        },
        items: []
      }
    };
  },
  methods: {
    /**
     * 保存
     */
    save() {
      var me = this,
        main = me.form.main;
      if (!main.pc_opinion) {
        me.$weui.topTips("请输入项目总结意见", 2000);
      } else {
        me.p_save();
      }
    },
  }
};
</script>